import { useMemo } from 'react';
import type { CalendarEvent, CalendarRow, Period, PromoTypeLegendItem } from '../../../../types/calendar';

export function usePromoTypeLegend(dataSource: CalendarRow[], periods: Period[]): PromoTypeLegendItem[] {
    return useMemo(() => {
        const typeMap = new Map<string, { color: string; bgColor: string }>();
        const collectFromRows = (rows: CalendarRow[]) => {
            rows?.forEach((row) => {
                periods.forEach((p) => {
                    const events = row[p.period_start_date] as CalendarEvent[] | undefined;
                    events?.forEach((evt) => {
                        if (evt.promoType && !typeMap.has(evt.promoType)) {
                            typeMap.set(evt.promoType, { color: evt.color, bgColor: evt.bgColor });
                        }
                    });
                });
                if (row.children) collectFromRows(row.children);
            });
        };
        collectFromRows(dataSource);

        return Array.from(typeMap.entries()).map(([type, colors]) => ({
            type,
            color: colors.color,
        }));
    }, [dataSource, periods]);
}
